import React, { useMemo } from 'react'
import { mutualTheme } from '~/utils/theme'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { CircledText } from '~/components/'
import { StepIndicatorProps } from '../StepIndicator'
import clsx from 'clsx'

const useStyles = makeStyles({
  responsiveSteps: {
    display: 'flex',
    backgroundColor: '#FFF',
    height: '50px',
    width: '100vw',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: mutualTheme.spacing(1)
  },
  stepSeparator: {
    backgroundColor: '#DFDFDF',
    width: '8px',
    height: '2px',
    marginRight: '4px',
    marginLeft: '4px'
  },
  subStep: {
    width: 5,
    height: 5,
    borderRadius: '50%',
    backgroundColor: '#C4C4C4'
  },
  activedSeparator: {
    backgroundColor: mutualTheme.palette.blue.main
  },
  completedSubStep: {
    backgroundColor: '#05C370'
  }
})

export const ResponsiveStepIndicator = (props: StepIndicatorProps) => {
  const { currentPage } = props
  const classes = useStyles()

  const renderResult = useMemo(() => {
    return (
      <Box className={classes.responsiveSteps}>
        <CircledText
          circleText='1'
          disabled={false}
          finished={currentPage > 0}
        />
        <Box className={clsx(classes.stepSeparator, {
          [classes.activedSeparator]: currentPage > 0
        })} />
        <CircledText
          circleText='2'
          disabled={currentPage < 1}
          finished={currentPage > 1}
        />
        <Box className={clsx(classes.stepSeparator, {
          [classes.activedSeparator]: currentPage > 1
        })} />
        <CircledText
          circleText='3'
          disabled={currentPage < 2}
          finished={currentPage > 2}
        />
        <Box className={clsx(classes.stepSeparator, {
          [classes.activedSeparator]: currentPage > 2
        })} />
        <CircledText
          circleText='4'
          disabled={currentPage < 3}
          finished={currentPage > 4}
        />
        <Box className={clsx(classes.stepSeparator, {
          [classes.activedSeparator]: currentPage >= 3
        })} />
        {currentPage >= 3 && currentPage < 5 && (
          <>
            <Box className={clsx(classes.subStep, {
              [classes.activedSeparator]: currentPage === 3,
              [classes.completedSubStep]: currentPage > 3
            })} />
            <Box className={clsx(classes.stepSeparator, {
              [classes.activedSeparator]: currentPage >= 4
            })} />
          </>
        )}
        {currentPage >= 3 && currentPage < 5 && (
          <>
            <Box className={clsx(classes.subStep, {
              [classes.activedSeparator]: currentPage >= 4
            })} />
            <Box className={classes.stepSeparator} />
          </>
        )}
        <CircledText
          circleText='5'
          disabled={currentPage < 5}
          finished={currentPage > 5}
        />
      </Box>
    )
  }, [currentPage])

  return (
    <>
      {renderResult}
    </>
  )
}
